import { SerializedStyles, css, useTheme } from "@emotion/react";
import { 
  fontSizeLineHeight,
  mediaQueries,
  pxToRem,
  transition,
  weights,
  focusStyles,
  focusStylesDark,
} from "@upsun/react-component-library/src/styles";
import React from 'react';
import { colors } from "../utils/colors";
import { Link } from "gatsby";
import { UpsunTheme } from "@upsun/react-component-library/src/themes";

type BackLinkProps = {
  text: string,
  btnHref: string,
  css?: SerializedStyles
}

export const BackLink:React.FC<BackLinkProps> = ({ text, btnHref, ...props }) => {
  const theme = useTheme() as UpsunTheme;
  
  const backBtnCss = css`
    display: inline-flex;
    position: relative;
    padding-left: ${pxToRem(28)};
    text-decoration: none;
    color: ${theme.name === "light" ? colors.black700 : colors.black300};
    ${fontSizeLineHeight(16, 24)}
    font-weight: ${weights.bold};
    letter-spacing: 0.1em;
    font-family: "Space Grotesk", sans-serif;
    
    ${mediaQueries.lg} {
      ${fontSizeLineHeight(18, 24)};
    }
    
    svg {
      position: absolute;
      top: ${pxToRem(0)};
      left: 0;
      transform: translateX(0);
      transition: ${transition()};
    }
    
    path {
      fill: ${theme.name === "light" ? colors.black700 : colors.black300};
    }
    
    &:hover,
    &:focus {
      svg {
        transform: translateX(${pxToRem(-1)});
      }
    }
    
    &:focus-visible {
      ${theme.name === "light" ? focusStyles : focusStylesDark}
    }
  `

  return (
    <Link to={ btnHref } css={backBtnCss} {...props}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.2 6.79999C14.5 6.79999 14.7 6.89999 14.9 7.09999C15.3 7.49999 15.3 8.09999 14.9 8.49999L11.4 12L14.9 15.5C15.3 15.9 15.3 16.5 14.9 16.9C14.5 17.3 13.9 17.3 13.5 16.9L9.30001 12.7C8.90001 12.3 8.90001 11.7 9.30001 11.3L13.5 7.09999C13.7 6.89999 13.9 6.79999 14.2 6.79999Z" fill="#797477"/>
      </svg>
      {text}
    </Link>
  );
}